var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6598 3.33567C31.2045 4.7671 25.4793 8.41298 22.2152 14.5862C16.3669 25.6465 18.8548 33.7416 16.8096 41.9144C14.7644 50.0872 8.49422 52.8267 3.98446 59.2235C0.464391 64.2165 -0.0916519 76.3614 6.21657 82.4254C12.4574 88.3771 18.2125 93.8957 29.4175 92.2142C40.5101 90.6 46.1028 83.1241 57.757 80.7915C69.4112 78.4589 79.0635 80.5947 85.2654 75.0595C91.7689 69.2552 98.5338 53.2015 92.7229 41.6144C88.0489 32.2944 76.6847 30.2078 71.1405 21.4719C65.5964 12.7361 64.5 11 58.1544 6.75725C52.1574 2.74761 46.5692 2.16597 39.6598 3.33567Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMask);
export default __webpack_public_path__ + "static/media/avatar-mask.d2027901ad5d64497956b0f393fe30bb.svg";
export { ForwardRef as ReactComponent };